<script lang="ts">
  import type { Episode, Appearances } from "$types";
  import { dev } from "$app/environment";
  import { test_social_share_images } from "$config";
  import { PUBLIC_PROJECT } from "$env/static/public";
  import { episodeDate } from "$lib/dates";

  export let episode: Episode;
  export let location: string = "";

  // formatting the guest names into something nice to use in the meta tags
  let guests = (appearances?: Appearances[]) => {
    let temp: string[] = [];
    if (!appearances) return null;
    appearances.forEach((appearance: Appearances) => {
      temp.push(appearance.guests?.name ?? "");
    });
    if (!temp.length) return null;
    if (temp.length == 1) return temp[0];
    let last = temp.pop();
    return temp.join(", ") + " and " + last;
  };

  let title = `Episode #${episode.episode_number} featuring ${
    guests(episode.guests) ?? "A Craft Roulette Episode"
  }`;

  let description = `Episode #${
    episode.episode_number
  } of Craft Roulette aired on ${episode.date ? episodeDate(episode.date) : "Friday"}.`;

  let image_sub = `Hosted by Mary Gunn FUNN`;
  if (episode.guests?.length) {
    image_sub = `Featuring ${guests(episode.guests) ?? ""}`;
  }

  const siteName: string = "CraftRoulette.live";
  let url_string: string = `${PUBLIC_PROJECT}/episodes/episode-${episode.episode_number}`;

  let image_url: string = `${PUBLIC_PROJECT}/api/images/social/episode?e=${episode.episode_number}`;

  if (location !== "") {
    image_url = image_url + `&l=${location}`;
    if (location === "guest-info-and-links") {
      url_string = url_string + `/guests`;
      title = `Guest Info & Links - ${title}`;
    } else if (location === "process-videos") {
      title = `Process Videos - ${title}`;
    } else if (location === "in-revue") {
      title = `In Revue - ${title}`;
    } else {
      url_string = url_string + `/${location}`;
    }
  }
</script>

<svelte:head>
  <title>{title} - Craft Roulette</title>
  <meta name="robots" content="all" />
  <meta name="title" content="{title} - {siteName}" />
  <meta name="description" content={description} />

  <meta property="og:type" content="website" />
  <meta property="og:url" content={url_string} />
  <meta property="og:title" content="{title} - {siteName}" />
  <meta property="og:description" content={description} />

  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content={url_string} />
  <meta property="twitter:title" content="{title} - {siteName}" />
  <meta property="twitter:description" content={description} />

  <meta property="twitter:image" content={image_url} />
  <meta property="og:image" content={image_url} />

  <link rel="canonical" href={url_string} />
</svelte:head>

{#if test_social_share_images && dev}
  <div class="tester">
    <img src={image_url} alt="test social share graph" />
  </div>
{/if}

<style>
.tester {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  width: 600px;
  height: auto;
  z-index: 1000;
}
.tester img {
  width: 100%;
  height: auto;
  border: 1px solid #333;
  border-radius: 5px;
}
</style>
